import {
    DashboardOutlined,
    PeopleOutlined,
    Autorenew,
    ArrowUpward,
    Settings,
    EqualizerOutlined,
} from '@mui/icons-material';
import { MdCampaign, MdOutlineContactMail, MdOutlineDynamicForm, MdOutlineLabel, MdOutlineSegment, MdOutlineImportContacts } from "react-icons/md";
import { RiDashboardLine } from "react-icons/ri";
import { HiOutlineUsers } from "react-icons/hi2";
import { TbAutomation } from "react-icons/tb";

const adminMenuItems = [
    {
        label: 'Dashboard',
        icon: <RiDashboardLine size={20} />,
        to: '/admin/dashboard',
    },
    {
        label: 'Email Templates',
        icon: <MdOutlineContactMail size={20} />,
        to: '/admin/email-templates',
    },
    {
        icon: <EqualizerOutlined size={20} />,
        label: 'Server Status',
        to: '/admin/server-status',
    },
    {
        icon: <HiOutlineUsers size={20} />,
        label: 'Users',
        to: '/admin/users',
    },

    {
        icon: <Autorenew size={20} />,
        label: 'Queue',
        to: '/admin/queue',
    },
    {
        icon: <ArrowUpward size={20} />,
        label: 'Upgrade Plans',
        to: '/admin/plans',
    },
    {
        icon: <Settings size={20} />,
        label: 'Settings',
        to: '/admin/settings',
    },
];

const userMenuItems = [
  {
    icon: <RiDashboardLine size={20} />,
    label: 'Dashboard',
    to: '/',
  },
  {
    icon: <HiOutlineUsers size={20} />,
    label: 'Contacts',
    to: '/contacts/dashboard',
    subTabs: [
      { label: 'Dashboard', icon: <RiDashboardLine size={18} />, to: '/contacts/dashboard' },
      { label: 'All Contacts', icon: <MdOutlineContactMail size={18} />, to: '/contacts/all' },
      { label: 'Signup Forms', icon: <MdOutlineDynamicForm size={18} />, to: '/contacts/signup-forms' },
      { label: 'Tags', icon: <MdOutlineLabel size={18} />, to: '/contacts/tags' },
      { label: 'Segments', icon: <MdOutlineSegment size={18} />, to: '/contacts/segments' },
      { label: 'Import', icon: <MdOutlineImportContacts size={18} />, to: '/contacts/import' },
    ],
  },
  {
    icon: <MdCampaign size={22} />,
    label: 'Campaigns',
    to: '/campaigns/all',
    subTabs: [
      { label: 'All Campaigns', icon: <MdCampaign size={18} />, to: '/campaigns/all' },
      { label: 'Email Templates', icon: <MdOutlineContactMail size={18} />, to: '/campaigns/templates' },
    ],
  },
  {
    icon: <TbAutomation size={22} />,
    label: 'Automation',
    to: '/automation',
  },
];

export { userMenuItems, adminMenuItems };
